import api from './api';

export default {
  login(email, password) {
    return api.post('/login/access-token', {
      username: email,
      password
    });
  },
  recoverPassword(email) {
    return api.post(`/recover-password/${email}`, { email });
  },
  resetPassword(password, token) {
    return api.postJSON('/reset-password', {
      new_password: password,
      token
    });
  },
  confirmAccount(password, token) {
    return api.postJSON('/confirm-account', {
      new_password: password,
      token
    });
  },
  fetchMe() {
    return api.get('/users/me');
  },
  updateMe(me) {
    return api.put('/users/me', me);
  },
  createApiKey() {
    return api.post('/users/me/api-key');
  },
  deleteApiKey() {
    return api.delete('/users/me/api-key');
  },
  resendConfirmUserEmail(id) {
    return api.post(`/users/${id}/resend-confirm-user-email`);
  },
  fetchRoles() {
    return api.get('/users/roles/', { limit: 100 });
  },
  fetchAccountManagers() {
    return api.get('/users/account-managers/');
  },
  createUser(user) {
    return api.postJSON('/users/', user);
  },
  updateUser(id, user) {
    return api.put(`/users/${id}`, user);
  },
  activateUser(id) {
    return api.put(`/users/${id}/activate`);
  },
  deactivateUser(id) {
    return api.put(`/users/${id}/deactivate`);
  },
  activateMachineUser(id) {
    return api.put(`/machine-users/${id}/activate`);
  },
  deactivateMachineUser(id) {
    return api.put(`/machine-users/${id}/deactivate`);
  },
  fetchGroups(rootGroupId) {
    return api.get(`/groups/${rootGroupId}`);
  },
  createGroup(group) {
    return api.postJSON('/groups/', group);
  },
  updateGroup(id, group) {
    return api.put(`/groups/${id}`, group);
  },
  activateGroup(id) {
    return api.put(`/groups/${id}/activate`);
  },
  deactivateGroup(id) {
    return api.put(`/groups/${id}/deactivate`);
  },
  checkEula(id) {
    return api.get(`/organizations/eula`);
  },
  acceptEula(id) {
    return api.post(`/organizations/eula`);
  },
  fetchOrganizations(params) {
    return api.get('/organizations/', params);
  },
  createOrganization(organization) {
    return api.postJSON('/organizations/', organization);
  },
  updateOrganization(id, organization) {
    return api.put(`/organizations/${id}`, organization);
  },
  fetchCountries() {
    return api.get('/countries/');
  },
  fetchServiceNowConnector() {
    return api.get(`/organizations/service-now`);
  },
  updateServiceNowConnector(serviceNow) {
    return api.put('/organizations/service-now', serviceNow);
  },
  deleteServiceNowConnector() {
    return api.delete('/organizations/service-now');
  },
  createPool(pool) {
    return api.postJSON('/pools/', pool);
  },
  fetchRecipients(poolId) {
    return api.get(`/pools/${poolId}/transfer-recipients/`);
  },
  transferLicenseToStore(requestKey, productName, licenseTypeName, notes) {
    return api.postJSON(`/pools/transfer-to-product-store`, {
      request_key: requestKey,
      product_name: productName,
      license_type_name: licenseTypeName,
      notes: notes,
    });
  },
  transferLicenseToPool(poolId, recipient) {
    return api.postJSON(`/pools/${poolId}/transfer-to-pool`, recipient);
  },
  fetchTransactions(poolId, params) {
    return api.get(`/pools/${poolId}/transactions/`, params);
  },
  fetchLicenseTypes() {
    return api.get(`/license-types/`);
  },
  fetchOrganizationLicenseTypes(organizationId) {
    return api.get(`/organizations/${organizationId}/license-types/`);
  },
  fetchGroupLicenseTypes(groupId) {
    return api.get(`/groups/${groupId}/license-types-available/`);
  },
  creditLicenses(poolId, licenses) {
    return api.postJSON(`/pools/${poolId}/credit-pool`, licenses);
  },
  fetchProducts() {
    return api.get(`/products/`);
  },
  createVersion(version) {
    return api.postJSON(`/versions/`, version);
  },
  updateVersion(id, version) {
    return api.put(`/versions/${id}`, version);
  },
  createDownload(download) {
    return api.postJSON(`/downloads/`, download);
  },
  updateDownload(id, download) {
    return api.put(`/downloads/${id}`, download);
  },
  fetchDeviceReports(params) {
    return api.get('/device-reports/', params);
  },
  fetchDeviceReport(deviceReportId) {
    var report = api.get(`/device-reports/${deviceReportId}`);
    return report;
  },
  fetchEnrollments(params) {
    return api.get('/enrollments/', params);
  },
  fetchEnrollment(enrollmentId) {
    var enrollment = api.get(`/enrollments/${enrollmentId}`);
    return enrollment;
  },
  autopilotImport(enrollment) {
    var autopilotStatus = api.postJSON(`/enrollments/autopilot/`, enrollment);
    return autopilotStatus;
  },
  autopilotReimport(enrollmentId) {
    var autopilotStatus = api.put(`/enrollments/autopilot/${enrollmentId}`);
    return autopilotStatus;
  },
  fetchTasks() {
    return api.get('/tasks/');
  },
  deleteTask(id) {
    return api.delete(`/tasks/${id}`);
  },
}
